import React from 'react';

export const Search = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="11" cy="10" r="6" stroke="black" strokeWidth="1.5" />
    <line
      stroke="black"
      strokeWidth="1.5"
      x1="15.5303"
      x2="21.5303"
      y1="14.4697"
      y2="20.4697"
    />
  </svg>
);
